import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Visibility as VisibilityIcon,
  Person as PersonIcon,
  Flag as FlagIcon,
  Download as DownloadIcon,
} from '@mui/icons-material';
import { SiteAnalytics } from '../../../types/analytics';
import { StatCard } from '../common';

export interface AnalyticsStatsCardsProps {
  analyticsData: SiteAnalytics | null;
  comparisonAnalyticsData: SiteAnalytics | null;
}

export const AnalyticsStatsCards: React.FC<AnalyticsStatsCardsProps> = ({
  analyticsData,
  comparisonAnalyticsData,
}) => {
  // スワイプ完走率の計算
  const totalPages = analyticsData?.pageData.length || 0;
  let currentRate = 0;
  if (totalPages > 0) {
    const lastPage = analyticsData?.pageData[totalPages - 1];
    const firstPageViews = analyticsData?.metrics.pageViews || 0;
    const lastPageViews = lastPage?.pageViews || 0;
    if (firstPageViews > 0) {
      currentRate = (lastPageViews / firstPageViews) * 100;
    }
  }

  const comparisonTotalPages = comparisonAnalyticsData?.pageData.length || 0;
  let comparisonRate = 0;
  if (comparisonTotalPages > 0 && totalPages > 0) {
    const comparisonFirst = comparisonAnalyticsData?.metrics.pageViews || 0;
    const comparisonLast = comparisonAnalyticsData?.pageData[comparisonTotalPages - 1]?.pageViews || 0;
    if (comparisonFirst > 0) {
      comparisonRate = (comparisonLast / comparisonFirst) * 100;
    }
  }

  return (
    <Box sx={{ mb: 3, px: 3 }}>
      <Typography sx={{ fontSize: '18px', fontWeight: 600, color: '#000000', mb: 2 }}>
        全体統計
      </Typography>
      <Box display="flex" gap={2} flexWrap="wrap">
        {/* PV 表示回数 */}
        <StatCard
          variant="analytics"
          title="PV"
          subtitle="表示回数"
          value={analyticsData?.metrics.pageViews || 0}
          comparisonValue={comparisonAnalyticsData?.metrics.pageViews || 0}
          icon={<VisibilityIcon />}
          iconShape="circle"
        />

        {/* UU ユニークユーザー数 */}
        <StatCard
          variant="analytics"
          title="UU"
          subtitle="ユニークユーザー数"
          value={analyticsData?.metrics.uniqueUsers || 0}
          comparisonValue={comparisonAnalyticsData?.metrics.uniqueUsers || 0}
          icon={<PersonIcon />}
          iconShape="circle"
        />

        {/* スワイプ完走率 */}
        <StatCard
          variant="analytics"
          title="スワイプ完走率"
          value={totalPages === 0 ? '0%' : `${Math.round(currentRate)}%`}
          comparisonValue={comparisonTotalPages === 0 || totalPages === 0 ? '0%' : `${Math.round(comparisonRate)}%`}
          icon={<FlagIcon />}
          iconShape="circle"
        />

        {/* CTAクリック数 */}
        <StatCard
          variant="analytics"
          title="CTAクリック数"
          value={analyticsData?.metrics.ctaClicks || 0}
          comparisonValue={comparisonAnalyticsData?.metrics.ctaClicks || 0}
          icon={<DownloadIcon />}
          iconShape="circle"
        />
      </Box>
    </Box>
  );
};

